import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGurdService } from './services/auth-gurd.service';
import { RememberMeService } from './services/remember-me.service';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { RegistrationComponent } from './registration/registration.component';


const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate:[RememberMeService] },
  { path: 'forgot-password', component: ForgotpasswordComponent, canActivate:[RememberMeService] },
  { path: 'signup', component: RegistrationComponent},

  //User One 1
  {
    path: 'dashboard',
    loadChildren: () => import('./User_One/user-one/user-one.module')
    .then((m) => m.UserOneModule)
    .catch((err) => console.log(err)),
    canActivate:[AuthGurdService]
  }, {
    path: 'privacy',
    loadChildren: () => import('./privacy/privacy.module').then(m => m.PrivacyModule)
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
